import { FC } from 'react';
import { SvgProps } from '../interfaces/Icon';

const OpenEye: FC<SvgProps> = ({ size, className, color }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 5.5C7.80342 5.5 4.24014 8.22202 2.98497 11.9984L2.98487 11.9987C2.98405 12.0012 2.98405 12.0038 2.98487 12.0063L2.03603 12.322L2.98472 12.0058C4.2427 15.7807 7.80522 18.5 12 18.5C16.1966 18.5 19.7598 15.778 21.014 12.0018L21.0152 11.998L21.0157 11.9983L21.0157 11.9982L21.0143 11.9942C19.7563 8.2192 16.1947 5.5 12 5.5ZM1.08716 11.3673C2.60607 6.79783 6.91671 3.5 12 3.5C17.0813 3.5 21.3897 6.7948 22.9117 11.3618C23.0505 11.7753 23.0498 12.2216 22.9114 12.6341C21.393 17.2029 17.0827 20.5 12 20.5C6.9188 20.5 2.60932 17.2053 1.08731 12.6382L1.08716 12.6377C0.949985 12.2255 0.949952 11.7799 1.08706 11.3676"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 10C11.4696 10 10.9609 10.2107 10.5858 10.5858C10.2107 10.9609 10 11.4696 10 12C10 12.5304 10.2107 13.0391 10.5858 13.4142C10.9609 13.7893 11.4696 14 12 14C12.5304 14 13.0391 13.7893 13.4142 13.4142C13.7893 13.0391 14 12.5304 14 12C14 11.4696 13.7893 10.9609 13.4142 10.5858C13.0391 10.2107 12.5304 10 12 10ZM9.17157 9.17157C9.92172 8.42143 10.9391 8 12 8C13.0609 8 14.0783 8.42143 14.8284 9.17157C15.5786 9.92172 16 10.9391 16 12C16 13.0609 15.5786 14.0783 14.8284 14.8284C14.0783 15.5786 13.0609 16 12 16C10.9391 16 9.92172 15.5786 9.17157 14.8284C8.42143 14.0783 8 13.0609 8 12C8 10.9391 8.42143 9.92172 9.17157 9.17157Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default OpenEye;
